// @mui
import { Stack } from '@mui/material';
//
import { NavSectionProps } from '../types';
import { useUserRole } from 'src/hooks/useUserRole';
import { roleHasPageAccess } from 'src/auth/rbac';
import NavSection from './NavSection';

// ----------------------------------------------------------------------

export default function NavSectionVertical({ data, sx, ...other }: NavSectionProps) {
  const { data: role } = useUserRole();

  return (
    <Stack sx={sx} {...other}>
      {data.map((group) => {
        const key = group.subheader || group.items[0].title;
        const hasAccess = role && group.items.some((item) => roleHasPageAccess(item.path, role));

        if (hasAccess) {
          return <NavSection key={key} group={group} />;
        }
      })}
    </Stack>
  );
}
